export default __webpack_public_path__ + "static/media/725.55853746.png";